import Database from "crane-query-builder/src/Database"
import Connection from "react-native-jala-orm/src/Connection"
import SQLiteGrammar from "react-native-jala-orm/src/query/grammars/SQLiteGrammar"

export default class WebConnection extends Connection {
  /**
   * Create a new database connection instance.
   *
   * @param  {PDO|Function}     pdo
   * @param  {String}   database
   * @param  {String}   tablePrefix
   * @param  {Object}    config
   * @return void
   */
  constructor(pdo, database = '', tablePrefix = '', config = {name: 'rn-sqlite'})
  {
    super(pdo, database, tablePrefix, config)
    Database.Connection = WebConnection
    Database.Grammar = SQLiteGrammar
    // Database.database = Database.database || Database.Connection.connect({
    //   driver: SQLite,
    //   name: 'Jala.db',
    //   location: 'default',
    //   createFromLocation: '~www/Jala.db'
    // })
  }

  get(props) {
    return Promise.resolve([])
  }

  run({ sql, params, resolve, reject }) {
    if (resolve) resolve([])
    return Promise.resolve(true)
  }

  /**
   *
   * @param sqls
   * @param params
   * @returns {Promise<unknown>}
   */
  executeBulkSql (sqls, params = []) {
    return new Promise(function (resolve, reject) {
      Database.database.transaction(async function(tx) {
        const responses = [];
        for (let i = 0; i < sqls.length; i++) {
          const result = await new Promise<any>(function(resolve, reject) {
            tx.executeSql(
              sqls[i],
              params[i],
              (_, { rows, insertId }) => {
                resolve({ rows: rows.raw(), insertId })
              },
              (err, message) => {
                reject(err)
              }
            )
          }).catch((err) => reject(err))
          if (!result || !result.rows) return false;
          responses.push(result)
        }
        resolve(responses)
        return true;
      })
    })
  }
}
